var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    staticClass: "p-3",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleValidSubmit.apply(null, arguments);
      }
    }
  }, [_vm._l(_vm.forms, function (form, index) {
    var _vm$errors$index, _vm$errors$index2, _vm$errors$index3, _vm$errors$index4, _vm$errors$index5, _vm$errors$index6, _vm$errors$index7, _vm$errors$index8;
    return _c('div', {
      key: index,
      staticClass: "border card-form mb-3"
    }, [_c('b-row', {
      staticClass: "p-3"
    }, [_c('b-col', {
      staticClass: "d-flex justify-content-between",
      attrs: {
        "md": "12"
      }
    }, [_c('h5', {
      staticClass: "text-primary mb-3",
      staticStyle: {
        "font-weight": "500"
      }
    }, [_vm._v("Schedule Form")]), _c('div', [index > 0 ? _c('i', {
      staticClass: "fa fa-trash text-danger",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function click() {
          return _vm.deleteForm(index);
        }
      }
    }) : _vm._e()])]), _c('b-col', {
      attrs: {
        "md": "6"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Fleet Name *",
        "label-for": "fleet_name"
      }
    }, [_c('v-select', {
      staticClass: "bg-white",
      attrs: {
        "options": _vm.fleetsOpt,
        "placeholder": "Select Fleet",
        "label": "label",
        "track-by": "id",
        "reduce": function reduce(option) {
          return option.id;
        }
      },
      model: {
        value: form.vehicle_id,
        callback: function callback($$v) {
          _vm.$set(form, "vehicle_id", $$v);
        },
        expression: "form.vehicle_id"
      }
    }), (_vm$errors$index = _vm.errors[index]) !== null && _vm$errors$index !== void 0 && _vm$errors$index.vehicle_id ? _c('small', {
      staticClass: "text-danger"
    }, [_vm._v("This field is required.")]) : _vm._e()], 1)], 1), _c('b-col', {
      attrs: {
        "md": form.maintenance_type == 'service_and_repair' ? 3 : 6
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Maintenance Type *",
        "label-for": "maintenance_type"
      }
    }, [_c('v-select', {
      staticClass: "bg-white",
      attrs: {
        "required": "",
        "options": _vm.maintenanceTypes,
        "label": "label",
        "placeholder": "Select Fleet",
        "reduce": function reduce(option) {
          return option.value;
        },
        "track-by": "value"
      },
      model: {
        value: form.maintenance_type,
        callback: function callback($$v) {
          _vm.$set(form, "maintenance_type", $$v);
        },
        expression: "form.maintenance_type"
      }
    }), (_vm$errors$index2 = _vm.errors[index]) !== null && _vm$errors$index2 !== void 0 && _vm$errors$index2.maintenance_type ? _c('small', {
      staticClass: "text-danger"
    }, [_vm._v("This field is required.")]) : _vm._e()], 1)], 1), form.maintenance_type == 'service_and_repair' ? _c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Service & Repair Type *",
        "label-for": "maintenance_type"
      }
    }, [_c('v-select', {
      staticClass: "bg-white",
      attrs: {
        "required": "",
        "options": _vm.optionsTaskType,
        "placeholder": "Select Maintenance Type",
        "label": "label",
        "reduce": function reduce(option) {
          return option.id;
        },
        "track-by": "id"
      },
      model: {
        value: form.task_type_id,
        callback: function callback($$v) {
          _vm.$set(form, "task_type_id", $$v);
        },
        expression: "form.task_type_id"
      }
    }), (_vm$errors$index3 = _vm.errors[index]) !== null && _vm$errors$index3 !== void 0 && _vm$errors$index3.task_type_id ? _c('small', {
      staticClass: "text-danger"
    }, [_vm._v("This field is required.")]) : _vm._e()], 1)], 1) : _vm._e(), _c('b-col', {
      attrs: {
        "md": "6"
      }
    }, [_c('b-form-group', {
      attrs: {
        "required": "",
        "label": "Start Date *",
        "label-for": "start_date"
      }
    }, [_c('date-picker', {
      staticClass: "bg-white w-100",
      attrs: {
        "value-type": "YYYY-MM-DD",
        "type": "date",
        "placeholder": "Select date and time",
        "format": "DD-MM-YYYY"
      },
      model: {
        value: form.start_date,
        callback: function callback($$v) {
          _vm.$set(form, "start_date", $$v);
        },
        expression: "form.start_date"
      }
    }), (_vm$errors$index4 = _vm.errors[index]) !== null && _vm$errors$index4 !== void 0 && _vm$errors$index4.start_date ? _c('small', {
      staticClass: "text-danger"
    }, [_vm._v("This field is required.")]) : _vm._e()], 1)], 1), _c('b-col', {
      attrs: {
        "md": "6"
      }
    }, [_c('b-form-group', {
      attrs: {
        "required": (form.status || '') === 'closed',
        "label": "End Date".concat((form.status || '') === 'closed' ? ' *' : ''),
        "label-for": "end_date"
      }
    }, [_c('date-picker', {
      staticClass: "bg-white w-100",
      attrs: {
        "value-type": "YYYY-MM-DD",
        "type": "date",
        "placeholder": "Select date and time",
        "format": "DD-MM-YYYY"
      },
      model: {
        value: form.end_date,
        callback: function callback($$v) {
          _vm.$set(form, "end_date", $$v);
        },
        expression: "form.end_date"
      }
    }), (_vm$errors$index5 = _vm.errors[index]) !== null && _vm$errors$index5 !== void 0 && _vm$errors$index5.end_date ? _c('small', {
      staticClass: "text-danger"
    }, [_vm._v("End Date is required when status is Closed.")]) : _vm._e()], 1)], 1), _c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Remarks",
        "label-for": "end_date"
      }
    }, [_c('wysiwyg', {
      staticClass: "bg-white",
      style: {
        height: '200px'
      },
      attrs: {
        "id": "remark"
      },
      model: {
        value: form.remark,
        callback: function callback($$v) {
          _vm.$set(form, "remark", $$v);
        },
        expression: "form.remark"
      }
    })], 1)], 1), _c('b-col', {
      staticClass: "mt-2",
      attrs: {
        "md": "12"
      }
    }, [_c('h5', {
      staticClass: "text-primary mb-3",
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v("LOG STATUS")])]), _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Status Date *"
      }
    }, [_c('date-picker', {
      staticClass: "bg-white w-100",
      attrs: {
        "value-type": "YYYY-MM-DD HH:mm:ss",
        "type": "datetime",
        "placeholder": "Select date",
        "format": "DD-MM-YYYY HH:mm:ss"
      },
      model: {
        value: form.status_date,
        callback: function callback($$v) {
          _vm.$set(form, "status_date", $$v);
        },
        expression: "form.status_date"
      }
    }), (_vm$errors$index6 = _vm.errors[index]) !== null && _vm$errors$index6 !== void 0 && _vm$errors$index6.status_date ? _c('small', {
      staticClass: "text-danger"
    }, [_vm._v("This field is required.")]) : _vm._e()], 1)], 1), _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Status *"
      }
    }, [_c('v-select', {
      staticClass: "bg-white",
      attrs: {
        "options": _vm.filteredStatusOptions(form),
        "placeholder": "Select status",
        "label": "label",
        "reduce": function reduce(o) {
          return o.value;
        },
        "track-by": "value"
      },
      model: {
        value: form.status,
        callback: function callback($$v) {
          _vm.$set(form, "status", $$v);
        },
        expression: "form.status"
      }
    }), (_vm$errors$index7 = _vm.errors[index]) !== null && _vm$errors$index7 !== void 0 && _vm$errors$index7.status ? _c('small', {
      staticClass: "text-danger"
    }, [_vm._v("This field is required.")]) : _vm._e()], 1)], 1), _c('b-col', {
      attrs: {
        "md": "4"
      }
    }, [_c('b-form-group', {
      attrs: {
        "label": "Create By *"
      }
    }, [_c('v-select', {
      staticClass: "bg-white",
      attrs: {
        "options": _vm.creatorOptions,
        "placeholder": "Select creator",
        "label": "label",
        "reduce": function reduce(o) {
          return o.value;
        },
        "track-by": "value"
      },
      model: {
        value: form.user_id,
        callback: function callback($$v) {
          _vm.$set(form, "user_id", $$v);
        },
        expression: "form.user_id"
      }
    }), (_vm$errors$index8 = _vm.errors[index]) !== null && _vm$errors$index8 !== void 0 && _vm$errors$index8.user_id ? _c('small', {
      staticClass: "text-danger"
    }, [_vm._v("This field is required.")]) : _vm._e()], 1)], 1), _c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('b-table-lite', {
      attrs: {
        "items": _vm.logStatusList,
        "fields": _vm.logStatusFields,
        "small": "",
        "responsive": ""
      },
      scopedSlots: _vm._u([{
        key: "cell(date)",
        fn: function fn(_ref) {
          var item = _ref.item;
          return [_vm._v(_vm._s(_vm.formatDate(item.status_date)))];
        }
      }, {
        key: "cell(total_day)",
        fn: function fn(_ref2) {
          var item = _ref2.item;
          return [_vm._v(_vm._s(_vm.calcTotalDays(item.status_date, item)))];
        }
      }, {
        key: "cell(status)",
        fn: function fn(_ref3) {
          var item = _ref3.item;
          return [_vm._v(_vm._s(item.status))];
        }
      }, {
        key: "cell(created_by)",
        fn: function fn(_ref4) {
          var item = _ref4.item;
          return [_vm._v(_vm._s(item.user.detail.name))];
        }
      }], null, true)
    })], 1)], 1)], 1);
  }), _c('div', {
    staticClass: "d-flex justify-content-end mt-3"
  }, [_c('b-button', {
    staticClass: "mt-3 mr-2",
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Cancel")]), !_vm.selectedData ? _c('b-button', {
    staticClass: "mt-3 mr-2",
    attrs: {
      "size": "sm",
      "variant": "outline-primary",
      "type": "button"
    },
    on: {
      "click": _vm.addForm
    }
  }, [_vm._v("Add Form")]) : _vm._e(), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "size": "sm",
      "variant": "primary",
      "type": "submit",
      "loading": _vm.loading
    }
  }, [_vm._v("Submit")])], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }